import { Component, OnInit } from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {ModalHelper} from '../../../../services/modalService/modal.helper';

export interface Model {
  title: string;
  data: string;
}

@Component({
  selector: 'app-denial',
  templateUrl: './denial.component.html',
  styleUrls: ['./denial.component.css', '../../myreports.component.css']
})
export class DenialComponent extends DialogComponent<Model, any> implements OnInit {

  title: string;
  data: any;
  denials: any = [];
  totalDenials: number = 0;
  count: number = 0;
  currentUser: any;

  constructor(dialogService: DialogService,
              private modalHelper: ModalHelper) {
    super(dialogService);
  }

  ngOnInit() {
    this.denials = this.data.denials;
    this.totalDenials = this.data.totalDenials;
    this.count = this.data.count;
    this.currentUser = this.data.currentUser;
    document.getElementsByTagName('body')[0].classList.add('modal-open');
  }

    loginPrompt() {
        this.modalHelper.openLogin({});
    }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/denial/denial.component.ts